import { TELEGRAM_CHANNEL_LINK } from '~/shared/lib/socials';

export const FOOTER_SOCIALS = [
  {
    name: 'tg',
    link: TELEGRAM_CHANNEL_LINK,
  },
  {
    name: 'vk',
    link: 'https://vk.com/cre.russia',
  },
  {
    name: 'rutube',
    link: 'https://rutube.ru/channel/14434025/',
  } /* 
  {
    name: 'dzen',
    link: '#',
  },
  {
    name: 'vc',
    link: '#',
  }, */,
  {
    name: 'yt',
    link: 'https://www.youtube.com/@CreRussia/streams',
  },
  {
    name: 'rss',
    link: 'https://cre.ru/rss_list',
  },
];

export const FOOTER_LINKS = [
  {
    title: 'Условия приобретения билетов',
    link: 'https://cre.ru/conditions_for_purchasing_tickets',
  },
  {
    title: 'Политика персональных данных',
    link: 'https://cre.ru/privacy_policy',
  },
  {
    title: 'Лицензионное соглашение',
    link: 'https://cre.ru/license_agreement',
  },
];
